module.exports = __webpack_public_path__ + "static/media/game.8892e44c.svg";